import React from "react";
import { motion } from "framer-motion";
const CTA = () => {
  return (
    <div className="relative overflow-hidden  dark:bg-[#27272E] z-30 bg-[#5956e9] py-16 sm:py-24 lg:py-32">
      <div className="">
        <img
          src="https://new.axilthemes.com/demo/react/abstrak/images/others/bubble-12.png"
          alt=""
          className="absolute -mt-40 left-1/3 -z-10 w-[500px]"
        />
        <motion.div
        className="flex justify-center items-center h-full"
        initial={{y:100 ,x:-300}}
          animate={{ y:[100,-100,90,100] , x:[300,450,-150,300]}}
          transition={{ duration: 30, repeat: Infinity }}
        >
          <img
            src="https://new.axilthemes.com/demo/react/abstrak/images/others/bubble-15.png"
            alt=""
            className="absolute dark:opacity-60 opacity-100 z-20 "
          />
        </motion.div>
        <motion.div
        className="flex justify-center items-center h-full"
        initial={{y:100 ,x:-300}}
          animate={{ y:[100,-50,90,100] , x:[-300,-250,500,-300]}}
          transition={{ duration: 25, repeat: Infinity }}
        >
          <img
            src="https://new.axilthemes.com/demo/react/abstrak/images/others/bubble-14.png"
            alt=""
            className="absolute dark:opacity-70 opacity-100 z-40 "
          />
        </motion.div>
        <motion.div
        className="flex justify-center items-center h-full"
          animate={{ y:[100,250,90,100] , x:[-500,-550,-900,-500]}}
          transition={{ duration: 15, repeat: Infinity }}
        >
          <img
            src="https://new.axilthemes.com/demo/react/abstrak/images/others/bubble-13.png"
            alt=""
            className="absolute opacity-100 z-40 "
          />
        </motion.div>

        {/* small dots */}

        <motion.div
        className="flex justify-center items-center h-full"
          animate={{ y:[100,100,250,100] , x:[-1000,-550,-400,-1000]}}
          transition={{ duration: 16, repeat: Infinity }}
        >
          <img
            src="https://new.axilthemes.com/demo/react/abstrak/images/others/bubble-16.png"
            alt=""
            className="absolute dark:opacity-60 opacity-100 z-40 "
          />
        </motion.div>
        <motion.div
        className="flex justify-center items-center h-full"
          animate={{ y:[-130,20,20,-130] , x:[-400,300,-450,-400]}}
          transition={{ duration: 20, repeat: Infinity }}
        >
          <img
            src="https://new.axilthemes.com/demo/react/abstrak/images/others/bubble-16.png"
            alt=""
            className="absolute opacity-70 z-40 "
          />
        </motion.div>
        <motion.div
        className="flex justify-center items-center h-full"
          animate={{ y:[90,-130,250,90] , x:[400,600,1100,400]}}
          transition={{ duration: 30, repeat: Infinity }}
        >
          <img
            src="https://new.axilthemes.com/demo/react/abstrak/images/others/bubble-16.png"
            alt=""
            className="absolute opacity-100 z-40 "
          />
        </motion.div>
      </div>
      <div className="mx-auto max-w-7xl z-50 px-6 lg:px-8">
        <div className="mx-auto max-w-2xl">
          <div className="flex flex-col justify-center items-center">
            <h1 className="text-3xl text-center font-bold z-50 dark:text-[#d3d3d4] tracking-tight text-white sm:text-4xl">
              Let’s Start <br /> Your Business Today!
            </h1>
            <p className="mt-4 z-50 text-lg leading-8 text-black-300 text text-white dark:text-[#d3d3d4]">
              Missing something? Just tell us what you need by requesting us
              here.
            </p>
            <div className="mt-6 flex max-w-md gap-x-4">
              <label
                htmlFor="email-address"
                className="sr-only dark:text-[#d3d3d4]"
              >
                Email address
              </label>
              <input
                id="email-address"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="min-w-0 flex-auto rounded-md border-0 bg-white/5 px-3.5 py-2 text-white shadow-sm ring-1 ring-inset ring-white/10 focus:ring-2 focus:ring-inset focus:ring-indigo-500 sm:text-sm sm:leading-6"
                placeholder="Enter your email"
              />
              <button
                type="submit"
                className="flex-none rounded-md bg-indigo-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
              >
                Subscribe
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTA;
